import styled from "styled-components";

import variables from "../../../styles/variables";
import TextLink from "../../UI/TextLink/TextLink";
import Image from "../../UI/Image/Image";

export const Section = styled.section`
  max-width: ${variables.defaultWidth}px;
  padding: 0 ${variables.layoutPadding}rem;
  margin: 40px auto;

  @media screen and (max-width: 1023px) {
    max-width: ${variables.defaultWidth}px;
    padding: 0 ${variables.mobileLayoutPadding}rem;
  }
`;

export const Container = styled.div`
  margin: 0 auto;
  border-radius: 20px;
  background: #f9dada;
  box-shadow: 2px 4px 12px 0px rgba(0, 0, 0, 0.08);
`;

export const InfoContainer = styled.div`
  display: flex;
  padding: 20px;
  justify-content: space-between;
  column-gap: 20px;
  align-items: center;

  @media screen and (max-width: 860px) {
    flex-direction: column;
    row-gap: 8px;
    align-items: flex-start
  }
`;

export const RedeemPoints = styled.div`
  color: ${variables.colorBlack};
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px;
  margin-bottom: 0;

  @media screen and (max-width: 767px) {
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
    margin-bottom: 1rem;
  }
`;

export const LowerPrice = styled.div`
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  @media screen and (max-width: 767px) {
    margin-bottom: 2rem;
  }
  @media screen and (max-width: 430px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const HeadingLink = styled(TextLink)`
  margin-bottom: 0;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  clear: both;

  @media screen and (max-width: 767px) {
    position: relative;
    top: 1rem;
  }
`;

export const BodyLink = styled(TextLink)`
  margin-bottom: 0;
  font-size: 20px;
  font-weight: 600;
  clear: both;

  @media screen and (max-width: 767px) {
    position: relative;
    top: 1rem;
  }

  @media screen and (max-width: 430px) {
    font-size: 16px;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;

  @media screen and (max-width: 767px) {
    width: 100%;
    padding-top: 1rem;
  }
`;

export const Logo = styled(Image)`
  max-width: 227px;
  @media screen and (max-width: 430px) {
    max-width: 128px;
  }
`;
